import {
  ref, reactive,
} from '@vue/composition-api'
import axiosIns from '@/libs/axios'
import { dateFormat } from '@/utils/date-format'
import { errorNotification, successNotification } from '@/utils/toast-notifications'

export default function useSubscriptionPlans(ctx) {
  const tableColumns = [
    {
      key: 'name',
    },
    {
      key: 'description',
      formatter: (_, _1, item) => (item.description ? item.description : '_'),
    },
    {
      key: 'is_active',
    },
    {
      key: 'target',
    },
    {
      key: 'country',
    },
    { key: 'created_at', label: 'Created At', formatter: val => dateFormat(val) },

    'actions',
  ]
  const list = ref([])
  const total = ref(0)
  const loadingPlans = ref(false)
  const queryParams = reactive({
    target: undefined,
    activeOnly: true,
    page: 1,
    perPage: 10,
  })
  const currTarget = ref('All')
  const targetOptions = [
    { label: 'All', key: 'All' },
    { label: 'Drivers', key: 'driver' },
    { label: 'Riders', key: 'rider' },
  ]
  const textFormatter = text => {
    if (!text) return '_'
    const temp = `${text.slice(0, 20)}<br /> ${text.slice(21, 40)}`
    if (text.length > 40) return `${temp}...`
    return temp
  }
  const fetchPlans = async () => {
    loadingPlans.value = true
    try {
      const temp = { ...queryParams }
      if (currTarget.value === 'All') {
        temp.target = undefined
      } else {
        temp.target = currTarget.value
      }
      if (queryParams.name) {
        delete temp.page
        delete temp.perPage
      }
      const result = await axiosIns.get('/subscription-plans', {
        params: temp,
      })
      const { SubscriptionPlans, total: totalRecords } = result.data.data
      list.value = SubscriptionPlans
      total.value = totalRecords
    } catch (error) {
      console.log(error)
    } finally {
      loadingPlans.value = false
    }
  }
  const search = () => {
    fetchPlans()
  }

  const selectedPlan = ref(null)
  const statusModal = ref(null)
  const modalLoading = ref(false)

  const openStatusModal = plan => {
    selectedPlan.value = plan
    statusModal.value.show()
  }

  const togglePlanStatus = async () => {
    if (!selectedPlan.value) return
    modalLoading.value = true

    try {
      if (selectedPlan.value.is_active) {
        await axiosIns.post(`subscription-plans/${selectedPlan.value.id}/deactivate`)
      } else {
        await axiosIns.post(`subscription-plans/${selectedPlan.value.id}/activate`)
      }
      await fetchPlans()
      successNotification('Success')
      statusModal.value.hide()
    } catch (err) {
      errorNotification('An error occured')
      console.error('Failed to change status:', err)
    } finally {
      modalLoading.value = false
    }
  }

  const viewPlanDetails = plan => {
    selectedPlan.value = plan
    ctx.root.$bvModal.show('subscription-plan-details')
  }
  fetchPlans()

  return {
    viewPlanDetails,
    statusModal,
    modalLoading,
    selectedPlan,
    openStatusModal,
    togglePlanStatus,
    tableColumns,
    loadingPlans,
    queryParams,
    targetOptions,
    search,
    total,
    currTarget,
    fetchPlans,
    textFormatter,
    list,
  }
}
